import React from 'react';

import GarageView from 'commons-garage/components/Garage/GarageView.jsx';
import GarageProvider from 'commons-garage/GarageProvider.jsx';

import en from 'commons-garage/i18n/en.json';
import fr from 'commons-garage/i18n/fr.json';

const root = GarageView;
const provider = GarageProvider;
const main = provider;

const Translations = { en, fr };

const widgets = {
    main,
};

export { widgets, Translations };

export default {
    root,
    provider,
    Garage: main,
    React,
    Translations,
};
